import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Box, Grid } from '@material-ui/core';

export const MainContainer = styled.div`
    display: flex;
    align-content: 'left';
    color: #140f4b;
    ${media.mobileDevice`
        background-color: 'red';
    `};
`;

export const EditImage = styled.p`
    display: flex;
    font-weight: bold;
    font-size: 10px;
`;

export const ReviewContainer = styled.div`
    display: inline-flex;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        justify-content: space-between;
        margin: 0px;
    `}
`;
export const SignatureTitle = styled.span`
    font-weight: bold;
    line-height: 28px;
    display: flex;
    font-size: 10px;
`;

export const ContractTitle = styled.p`
    font-weight: bold;
    line-height: 28px;
    display: flex;
    font-size: 10px;
    color: #202124;
`;

export const Data = styled.div`
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    color: ${({ color }) => (color ? color : '#202124')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    ${media.mobileDevice`
    margin: ${({ margin }) => (margin ? margin : '')};
    `}
`;

export const StyledDiv = styled.div`
    width: ${({ desktopWidth }) => (desktopWidth ? desktopWidth : '100%')};
    display: ${({ desktopDisplay }) => (desktopDisplay ? desktopDisplay : '')};
    justify-content: ${({ desktopJustifyContent }) =>
        desktopJustifyContent ? desktopJustifyContent : ''};
    ${media.mobileDevice`
           width:  ${({ width }) => (width ? width : '100%')};
           display: ${({ display }) => (display ? display : '')} ;
           justify-content: ${({ justifyContent }) =>
               justifyContent ? justifyContent : ''} ;
           
    `}
`;

export const LineSeparator = styled.hr`
    display: none;
    ${media.mobileDevice`
    border: 0;
    border-top: 2px solid #e8e8e8;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    display: flex;
    `}
`;
export const Title = styled.div`
    //font-family: AvenirNextWorld Demi;
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Demi'};
    color: ${(props) => (props.color ? props.color : '#202124')};
    width: ${(props) => (props.width ? props.width : '')};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
    padding-bottom: ${(props) => (props.paddingBtm ? props.paddingBtm : '0px')};
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '0px')};
    padding-right: ${(props) =>
        props.paddingRight ? props.paddingRight : '0px'};
    padding-left: ${(props) => (props.paddingLeft ? props.paddingLeft : '0px')};
    .asterisk {
        color: red;
        padding-left: 3px;
    }
    ${media.mobileDevice`
    width: ${(props) => (props.mbWidth ? props.mbWidth : '')};
    padding-bottom: ${(props) =>
        props.mbpaddingBtm ? props.mbpaddingBtm : '0px'};
    padding-top: ${(props) =>
        props.mbpaddingTop ? props.mbpaddingTop : '0px'};
         padding-right: ${(props) =>
             props.mbpaddingRight ? props.mbpaddingRight : '0px'};
    padding-left: ${(props) =>
        props.mbpaddingLeft ? props.mbpaddingLeft : '0px'};
    `};
`;
export const UploadImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 83px;
    height: 38px;
    border: 1px solid #1010eb;
    border-radius: 25px;
    font-size: 15px;
    font-family: AvenirNextWorld Demi;
    color: #1010eb;
    margin: 0px;

    ${media.mobileDevice`
        width: 30%;
        padding: 6px 16px;
        font-size: 15px;
        line-height: 27px;
        font-family: AvenirNextWorld Demi;
        color: #1010eb;
    `}
    & label {
        width: 100%;
        text-align: center;
        cursor: pointer;
    }
`;

export const AddRecipientContainer = styled.div`
    display: flex;
    align-items: ${({ alignItems }) => (alignItems ? alignItems : 'center')};
    padding: 5px 0;
    flex-direction: ${({ flexDirection }) => flexDirection};
    ${media.mobileDevice`
        flex-direction : column;
        justify-content: flex-start;
        align-items: flex-start;
    `}
`;
export const InputWithRecipientContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    ${media.mediumDevice`
        flex-direction: ${({ smFlexDirection }) => smFlexDirection};
        align-items: ${({ alignItems }) => alignItems};
    `}
    ${media.mobileDevice`
        width: 100%;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
    `}
`;

export const InputCont = styled.div`
    width: 70%;
    ${media.mediumDevice`
        width: ${({ smWidth }) => smWidth};
    `}
    ${media.mobileDevice`
        width: 100%;
    `}
`;

export const Add = styled.div`
    color: #1010eb;
    font-family: AvenirNextWorld Demi;
    font-size: 16px;
    margin: 0 10px;

    ${media.mobileDevice`
        margin: 10px 0;
    `}
`;

export const ErrorContainer = styled.span`
    color: #e71717;
    font-size: 12px;
    word-break: break-word;
`;

export const FileUploadContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 45%;
    ${media.mobileDevice`
           width: 100%;
    `}
`;
export const ReciepientContainer = styled.div`
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
        
    `}
`;
export const FileContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 90%;
    margin-top: 2px;
    font-size: 14px;
    color: #140f4b;
    text-align: left;
    opacity: 1;
    font-family: AvenirNextWorld Regular;
    ${media.mobileDevice`     
        width: 100%;   
    `};
`;
export const DocumentSection = styled.div`
    display: flex;
    justify-content: space-between;
    width: 80%;
    ${media.mobileDevice`
           width: 100%;
    `}
    ${media.smalDevice`
           width: 100%;
    `}
`;
export const FileAndReciepientContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 45%;
    ${media.mobileDevice`
           width: 100%;
    `}
`;
export const FileMainContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    ${media.mobileDevice`
         flex-direction: column;
    `}
`;

export const FileLinkContainer = styled.div`
    display: flex;
    margin-top: 16px;
`;
export const FileNameContainer = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    color: #140f4b;
    display: flex;
    width: 80%;
    word-break: break-word;
    ${media.mobileDevice`
      width: 90%;
    `}
`;
export const DeleteIconContainer = styled.div`
    display: flex;
    width: 32px;
    cursor: pointer;
`;
export const IconBorder = styled.div`
    width: 32px;
    height: 32px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border-radius: 6px;
    opacity: 1;
`;

export const StyledQuantityDiv = styled.div`
    display: none;
    ${media.smalDevice`
        display: flex;
    `}
`;
export const StyledTextDiv = styled.div`
    font-size: ${(props) => props.fSize && props.fSize};
    color: ${(props) => props.color && props.color};
    font-weight: ${(props) => props.fWeight && props.fWeight};
    font-family: ${(props) => props.fontFamily && props.fontFamily};
    padding: ${(props) => props.padding && props.padding};
`;
export const WrappedDiv = styled.div`
    display: none;
    ${media.smalDevice`
        display: flex;
        margin-top: 5px;
        width: 100%;
        justify-content: flex-end;
        align-items: center;
    `}
`;
export const StyledGrid = styled(Grid)`
    ${media.smalDevice`
        display: none;
    `}
`;

export const StyledBox = styled(Box)`
    ${media.smalDevice`
        display: none;
    `}
`;
